
import {mapState} from 'vuex'
import qualification from '../../api/qualification'
import axios from 'axios'
export default {

    data(){
        return {
            swiperOptions : {
                loop: true,
                effect: "coverflow",
            },
            quali : [],
            obj : null,
        }
    },
    created(){
        let code = this.$route.query.code;
        if(!this.flag || !code){
            this.$router.push('home')
            return;
        }
        this.getProduct(code)
        this.getquail();
    },
    computed:mapState({
        flag : state => state.flag
    }),
    watch:{

        flag:function(state){
            if(!state){
                this.$router.push('home')
            }
        }

    },
    methods:{

        getquail(){
            qualification.getHomeQua({
                num : 10
            }).then(res=>{
                this.quali = res;
            })
        },

        getProduct(url){
            // product.decodeQrcode({
            //     url
            // }).then(res=>{
            //     console.log(res)
            // })
            axios.post('http://47.95.36.14/jutong/sb/product/decodeQrcode',{url}).then(res=>{
                this.obj = res.data.data
                console.log(this.obj)
                console.log(res)
            })
        },

    }

}